"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCAL_NET = exports.DEV_NET = exports.MAIN_NET = exports.Network = void 0;
const web3_js_1 = require("@solana/web3.js");
var Network;
(function (Network) {
    Network[Network["DEV"] = 0] = "DEV";
    Network[Network["TEST"] = 1] = "TEST";
    Network[Network["MAIN"] = 2] = "MAIN";
    Network[Network["LOCAL"] = 3] = "LOCAL";
})(Network = exports.Network || (exports.Network = {}));
exports.MAIN_NET = {
    cyclos: new web3_js_1.PublicKey('CYS98pSt37MGGAD66StHE86gBVC8sYtgt96pPzvdKMnJ'),
    crankAuthority: new web3_js_1.PublicKey('CLWkDWLYgRqrZRgP1CZAMKNaQ9hqAbkjefy7SX2Yx2Zs'),
};
exports.DEV_NET = {
    cyclos: new web3_js_1.PublicKey('CYS98pSt37MGGAD66StHE86gBVC8sYtgt96pPzvdKMnJ'),
    crankAuthority: new web3_js_1.PublicKey('AFsdEoNszBh3fvVthHpR5di19Rgd6Ra4uotuR1ci3kNp'),
};
exports.LOCAL_NET = {
    cyclos: undefined,
    crankAuthority: new web3_js_1.PublicKey('AFsdEoNszBh3fvVthHpR5di19Rgd6Ra4uotuR1ci3kNp'),
};
